import api_base from '@/api/base';

export interface Specialization {
  key: string;
  ar: string;
  fr: string;
}

export interface Education {
  degree: string;
  institution: string;
  year: number;
}

export interface Certification {
  title: string;
  issuer: string;
  year: number;
}

export interface CareerEntry {
  role: string;
  cabinet: string;
  city: string;
  from: number;
  from_month: number | null;
  to: number | null;
  to_month: number | null;
  current: boolean;
}

export interface LawyerProfile {
  id: string;
  full_name: string;
  title: string;
  photo_path: string | null;
  photo_url: string | null;
  bar_city: string;
  full_name_fr: string;
  rattachement_year: number | null;
  // bio
  bio_ar: string;
  bio_fr: string;
  show_bio: boolean;
  // contact
  phone: string;
  whatsapp: string;
  email_public: string | null;
  website: string;
  linkedin: string;
  google_maps_url: string;
  show_contact: boolean;
  // cabinet location
  cabinet_address: string;
  cabinet_city: string;
  cabinet_country: string;
  // specializations
  specializations: Specialization[];
  show_specializations: boolean;
  // experience
  years_of_experience: number | null;
  show_experience: boolean;
  // education
  education: Education[];
  show_education: boolean;
  // certifications
  certifications: Certification[];
  show_certifications: boolean;
  // career
  career: CareerEntry[];
  show_career: boolean;
  // languages
  languages_spoken: string[];
  show_languages: boolean;
  // visibility
  is_published: boolean;
  // seo (read-only)
  slug: string;
  seo_title_fr: string;
  seo_title_ar: string;
  seo_description_fr: string;
  seo_description_ar: string;
  canonical_url: string;
  og_image_url: string;
  schema_type: string;
  // timestamps
  created_at: number;
  updated_at: number;
}

export type LawyerProfilePayload = Omit<
  LawyerProfile,
  | 'id' | 'photo_url' | 'created_at' | 'updated_at'
  | 'slug' | 'seo_title_fr' | 'seo_title_ar'
  | 'seo_description_fr' | 'seo_description_ar'
  | 'canonical_url' | 'og_image_url' | 'schema_type' | 'years_of_experience'
>;

export const get_lawyer_profile = async (): Promise<LawyerProfile | null> => {
  const response = await api_base.get('/api/v1/lawyer-profile/');
  if (response.status === 204) return null;
  return response.data;
};

export const create_lawyer_profile = async (body: Partial<LawyerProfilePayload>): Promise<LawyerProfile> => {
  const response = await api_base.post('/api/v1/lawyer-profile/', body);
  return response.data;
};

export const update_lawyer_profile = async (body: Partial<LawyerProfilePayload>): Promise<LawyerProfile> => {
  const response = await api_base.patch('/api/v1/lawyer-profile/update/', body);
  return response.data;
};

export const delete_lawyer_profile = async (): Promise<void> => {
  await api_base.delete('/api/v1/lawyer-profile/update/');
};

export const upload_lawyer_photo = async (file: File): Promise<{ photo_url: string; photo_path: string }> => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await api_base.post('/api/v1/lawyer-profile/photo/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}